// Main path on server
export const pathHomePage = "";
// Main youtube path
export const youtubeLink = "https://www.youtube.com/embed";

// Environments: production - development
const environment = "production";
export const WEB_SERVICE_ROUTE = `https://rgsweb.eodyne.com/rgsmims/backend/ossur/${environment}/src`;
export const WEB_SERVICE_MIMS = `${WEB_SERVICE_ROUTE}/mims`;

export const primaryColor = "#0182C4";
export const primaryColorHover = "#024b70";
export const errorColor = "#D9434E";
export const bodyColor = "#E6E6E6";
export const graphicDataColor1 = "#0182C4";
export const graphicDataColor2 = "#EE4D4D";
export const graphicDataColor3 = "#39b54a";
export const AdherenceColorLow = "#ed1c24";
export const AdherenceColorMedium = "#fbb03b";
export const AdherenceColorHigh = "#39b54a";
export const colorsArray = [
  "#0182C4",
  "#EE4D4D",
  "#39b54a",
  "#FDF201",
  "#004FA2",
  "#FF0E4B",
  "#FEB416",
  "#5D2D91",
  "#00AEF0",
  "#00A66C",
  "#F37520",
  "#303092",
  "#EB0089",
  "#A6CE3B",
  "#0072BB",
  "#E8371F",
  "#00A99E",
  "#92278F",
  "#FF6633",
  "#1AFF33",
  "#6666FF",
  "#E6B333",
];

export const pathologies = {
  otherId: 9,
  alzheimerId: 1,
  ataxiaId: 2,
  cerebralPalsyId: 3,
  multipleSclerosisId: 4,
  parkinsonId: 5,
  spinalCordInjuryId: 6,
  strokeId: 7,
  traumaticBrainInjuryId: 8,
  amputationId: 10,
};

export const applications = {
  clinicId: 1,
  homeId: 2,
};

export const protocols = {
  clinicAndHome: {
    TOWERS: {
      id: 20,
      isActive: true,
    },
    BALLOONS: {
      id: 30,
      isActive: true,
    },
    RUNNER: {
      id: 50,
      isActive: true,
    },
    CALIBRATION: {
      id: 40,
      isActive: false,
    },
    DATA_COLLECTION: {
      id: 60,
      isActive: false,
    },
    PRACTICE: {
      id: 70,
      isActive: false,
    },
  },
};

// Adherence
export const adherenceLevel = {
  lowToMedium: 50,
  MediumToHigh: 74,
};
